import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Table from "components/Table";

import priceRender from "libs/helpers/priceRender";

const walletValue = (wallet) => {
  const items = (wallet || []).filter((item) => item?.amount);

  if (!items.length) return "0";

  return items
    .map(({ amount, currency }) =>
      priceRender(((amount || 0) / 100).toFixed(2), currency),
    )
    .join(", ");
};

const ReferralProgramsTable = ({ data, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const tableData = {
    keys: [
      { key: "first_name", sort_key: false, value: t("Full name") },
      { key: "email", sort_key: false, value: t("Email") },
      { key: "active_plans", sort_key: false, value: t("Leads") },
      { key: "wallet", sort_key: false, value: t("Wallet") },
      { key: "details", sort_key: false, value: t("Details") },
    ],
    items: data?.map(({ id, first_name, last_name, email, leads, wallet }) => [
        { key: "first_name", value: `${first_name} ${last_name}` },
        { key: "email", value: email },
        { key: "active_plans", value: leads },
        {
          key: "wallet",
          value: walletValue(wallet),
        },
        {
          key: "details",
          type: "clickable_text",
          value: {
            label: t("View"),
            onclick: () => navigate(`/referral-program/${id}`),
          },
        },
      ],
    ),
  };

  return <Table data={tableData} loading={loading} />;
};

export default ReferralProgramsTable;